import { Module } from 'vuex';
import { actions } from '@/store/filters-regional/actions';
import { getters } from '@/store/filters-regional/getters';
import { mutations } from '@/store/filters-regional/mutations';
import { state } from '@/store/filters-regional/state';
import { RootState } from '@/models/states/root-state.model';
import { FiltersEventsRegionalState } from '@/models/states/filters-state.model';

const namespaced: boolean = true;

export const filtersEventsRegional: Module<FiltersEventsRegionalState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
